module.exports = __webpack_public_path__ + "fonts/montserrat-latin-300-normal.7e7ce57.woff";